/* src/app/shared/components/modals/generic-delete/generic-delete.component.scss */
.title {
  font-size: 32px;
  font-weight: 500;
  color: #007AC2;
}
.card .title {
  font-size: 18px;
  font-weight: 500;
  color: #2E3241;
  line-break: anywhere;
}
/*# sourceMappingURL=generic-delete.component.css.map */
